import { useEffect } from 'react';

/**
 * SSE bağlantısı — backend'den canlı event'leri dinle.
 *
 * @example
 *   useSseEvents((event) => {
 *     if (event.type === 'transaction.created') queryClient.invalidateQueries(['transactions']);
 *   });
 */
export function useSseEvents(handler: (event: { type: string; data: unknown }) => void) {
  useEffect(() => {
    const base = import.meta.env.VITE_API_BASE ?? '/api';
    const source = new EventSource(`${base}/sse/events`, { withCredentials: true });

    source.onmessage = (e) => {
      try {
        const parsed = JSON.parse(e.data);
        handler({ type: 'message', data: parsed });
      } catch {
        // ignore
      }
    };

    // Custom event types (transaction.created, alarm.created vb.)
    // NestJS @Sse MessageEvent.type → named SSE event; onmessage isimsiz event'leri
    // yakalar, isimli olanlar burada addEventListener ile dinlenmeli.
    const types = [
      'transaction.created',
      'card.status_changed',
      'alarm.created',
      'receipt.ocr_completed',
      'receipt.match_updated',
      'receipt.ocr_failed',
      'receipt.ocr_manual_review',
    ];
    types.forEach((type) => {
      source.addEventListener(type, (e: MessageEvent) => {
        try {
          handler({ type, data: JSON.parse(e.data) });
        } catch {
          // ignore
        }
      });
    });

    source.onerror = () => {
      // EventSource auto-reconnects; logging only
      // console.warn('SSE connection error');
    };

    return () => source.close();
  }, [handler]);
}
